// src/shared/http/error-handler.js
//
// Extracted from the original http-common.js AuthErrorHandler.
// Handles 401/403 responses with iframe awareness.

import { TokenService } from './token';
import { IframeUtil } from './iframe';

export const AuthErrorHandler = {
  isAuthError(error) {
    return (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    );
  },

  /**
   * Handle 401 Unauthorized.
   * In iframe context → notify parent.  Otherwise → reset store & redirect.
   * @param {Error}  [error]  - The original Axios error (optional).
   * @param {Router} [router] - Vue Router instance for programmatic nav.
   */
  handle401(error, router) {
    TokenService.removeToken();

    if (IframeUtil.isIframe()) {
      IframeUtil.postTokenExpired();
      return;
    }

    // Dynamic import avoids circular dependency with the store
    import('@/store')
      .then(({ default: store }) => {
        if (store.hasModule && store.hasModule('auth')) {
          store.commit('auth/RESET');
        }

        if (router) {
          router.push({ name: 'login' });
        } else {
          window.location.href = '#/login';
        }
      })
      .catch(() => {
        window.location.href = '#/login';
      });
  },

  /** Handle 403 Forbidden — redirect to 404 (RBAC violation). */
  handle403() {
    if (IframeUtil.isIframe()) {
      IframeUtil.debounceNotify('ERROR', {
        message: 'You do not have permission to perform this action.',
      });
      return;
    }
    import('@/router')
      .then(({ default: router }) => router.replace({ name: 'not-found' }))
      .catch(() => { window.location.hash = '#/'; });
  },

  /**
   * Unified handler — dispatches to handle401 or handle403 based on status.
   * Kept for backward compatibility with the Axios interceptors.
   */
  handleAuthError(error) {
    if (error?.response?.status === 403) {
      this.handle403(error);
    } else {
      this.handle401(error);
    }
  },
};
